// Lightweight feather-style icon set used by the v2 home page sections.
// Ported from the homepage handoff (components/icons.jsx) — only the
// icons referenced by the new sections are included.
import React from "react";

const Icon = ({ name, size = 18, color = "currentColor", strokeWidth = 1.75, ...rest }) => {
  const props = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
    ...rest,
  };
  switch (name) {
    case "search":
      return (<svg {...props}><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>);
    case "arrow-right":
      return (<svg {...props}><path d="M5 12h14M13 5l7 7-7 7" /></svg>);
    case "chevron-down":
      return (<svg {...props}><path d="M6 9l6 6 6-6" /></svg>);
    case "check":
      return (<svg {...props}><path d="M5 12l5 5L20 7" /></svg>);
    case "bell":
      return (<svg {...props}><path d="M6 16h12l-1.5-2V11a4.5 4.5 0 0 0-9 0v3L6 16z" /><path d="M10 19a2 2 0 0 0 4 0" /></svg>);
    case "edit":
      return (<svg {...props}><path d="M14 4l6 6L9 21H3v-6L14 4z" /></svg>);
    case "map-pin":
      return (<svg {...props}><path d="M12 21s7-6 7-11a7 7 0 0 0-14 0c0 5 7 11 7 11z" /><circle cx="12" cy="10" r="2.5" /></svg>);
    default:
      return null;
  }
};

export default Icon;
